// @ts-ignore
import { PROBLEM_INNER_TYPES } from '@yandex-int/k-common/constants';
import { StudentProblemResult } from '@yandex-int/k-common/typings';
import b from 'b_';
import cx from 'classnames';
import isNil from 'lodash/isNil';
import { Text } from 'platform-components';
import React from 'react';

import { CellDisplayParams } from 'common.components/results/typings';
import { getFormattedTime } from 'utils/get-formatted-time';
import { getOpenAnswerUrl } from 'utils/open-answer';

interface Props {
    displayParams: CellDisplayParams;
    problemResult: StudentProblemResult | null;
    shouldDisplayPoints: boolean;
    shouldDisplayAttempts: boolean;
}

// eslint-disable-next-line complexity
const ProblemDescription = (props: Props) => {
    const { displayParams, shouldDisplayPoints, shouldDisplayAttempts, problemResult } = props;

    if (!problemResult) {
        return null;
    }

    const {
        type: problemType,
        max_attempts: maxAttempts,
        attempt_number: attempts = null,
        time = null,
        points,
    } = problemResult;
    const { isOpenAnswer = false, isRobot = false, criteriaStats } = displayParams;

    const ftime = time !== null ? getFormattedTime(time) : '';
    const openAnswerLink = getOpenAnswerUrl(problemResult);
    const { finished_samples: finishedSamples, sample_number: sampleNumber } =
        problemResult.problem_specific_data || {};

    const shouldDisplayAttemptsForProblem =
        (problemType === PROBLEM_INNER_TYPES.ROBOT || problemType === PROBLEM_INNER_TYPES.PROBLEM) &&
        attempts !== null &&
        shouldDisplayAttempts;
    const shouldDisplayPointsForProblem =
        shouldDisplayPoints && !isNil(points) && problemType !== PROBLEM_INNER_TYPES.THEORY;

    if (!shouldDisplayAttemptsForProblem && !ftime && !isOpenAnswer && !shouldDisplayPoints) {
        return null;
    }

    return (
        <div>
            {isRobot && !isNil(finishedSamples) && (
                <div className="results__cell-description-row">
                    <div className="results__cell-description-property">
                        <Text id="lessonResults.problemResultsStatus.samples" />
                    </div>
                    <div className="results__cell-description-value">
                        <Text
                            id="lessonResults.outOf"
                            values={{ a: String(finishedSamples), b: String(sampleNumber) }}
                        />
                    </div>
                </div>
            )}
            {shouldDisplayAttemptsForProblem && (
                <div className="results__cell-description-row">
                    <div className="results__cell-description-property">
                        <Text id="lessonResults.problemResultsStatus.attempts" />
                    </div>
                    <div
                        className={cx('results__cell-description-value', 'qa_results-cell-description-value-attempts')}
                    >
                        {maxAttempts && !isRobot && !isOpenAnswer ? (
                            <Text id="lessonResults.outOf" values={{ a: String(attempts), b: String(maxAttempts) }} />
                        ) : (
                            <Text>{attempts}</Text>
                        )}
                    </div>
                </div>
            )}
            {shouldDisplayPointsForProblem && (
                <div className="results__cell-description-row">
                    <div className="results__cell-description-property">
                        <Text id="lessonResults.points" />
                    </div>
                    <div className={cx('results__cell-description-value', 'qa_results-cell-description-value-points')}>
                        <Text>{points}</Text>
                    </div>
                </div>
            )}
            {ftime && (
                <div className="results__cell-description-row">
                    <div className="results__cell-description-property">
                        <Text id="lessonResults.time" />
                    </div>
                    <div className={cx('results__cell-description-value', 'qa_results-cell-description-value-time')}>
                        <Text>{ftime}</Text>
                    </div>
                </div>
            )}
            {isOpenAnswer && (
                <div className="results__cell-description-row">
                    <div className="results__cell-description-property">
                        <Text id={`lessonResults.openAnswerLink.${openAnswerLink ? 'exists' : 'lacks'}`} />
                    </div>
                    {!criteriaStats && (
                        <div className="results__cell-description-value">
                            <div
                                className={b('results', 'cell-description-open-answer-value', {
                                    exists: Boolean(openAnswerLink),
                                })}
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProblemDescription;
